import Duck from "redux-ducks-ts"

export const expensiveorigin = new Duck("expensiveorigin", "cargo")
